import React from 'react';
import classes from './SkeletonArticle.module.scss';
import Skeleton from '../Skeleton';
import SkeletonArticlesCard from '../SkeletonArticlesCard/SkeletonArticlesCard';
import { GeneralContext } from '../../../context/generalContext';

export default function SkeletonArticle() {
  const { windowWidth } = React.useContext(GeneralContext);

  const items = [1, 2];
  const textDekstop = ['100%', '96%', '100%', '91%', '100%', '100%', '88%', '100%', '100%', '96%', '100%', '73%'];
  const additionalTextDekstop = ['100%', '100%', '96%', '73%'];
  const textMob = [
    '100%',
    '82%',
    '100%',
    '66%',
    '100%',
    '82%',
    '100%',
    '66%',
    '100%',
    '82%',
    '100%',
    '92%',
    '100%',
    '92%',
    '100%',
    '66%',
    '100%',
    '100%',
    '82%',
    '100%',
    '75%',
    '100%',
    '100%',
    '87%',
    '100%',
    '100%',
    '78%',
    '100%',
    '100%',
    '66%',
  ];

  return (
    <div className='wrapper'>
      <div className={classes.nav}>
        <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
      </div>
      <div className={classes.header}>
        <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
      </div>
      {windowWidth <= 430 && (
        <div className={classes.header2}>
          <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
        </div>
      )}

      <div className={classes.page}>
        <div className={classes.article}>
          <div className={classes.articleImg}>
            <Skeleton borderRadius='0px' width='100%' height='100%' isLight />
          </div>
          <div className={classes.textBlock}>
            <div className={classes.textTitle}>
              <Skeleton borderRadius='5px' width='100%' height={20} isLight={false} />
            </div>
            {windowWidth > 430 ? (
              <>
                {textDekstop.map((textWidth, index) => (
                  <div className={classes.text} key={index}>
                    <Skeleton borderRadius='5px' width={textWidth} height={15} isLight={false} />
                  </div>
                ))}
              </>
            ) : (
              <>
                {textMob.map((textWidth, index) => (
                  <div className={classes.text} key={index}>
                    <Skeleton borderRadius='5px' width={textWidth} height={15} isLight={false} />
                  </div>
                ))}
              </>
            )}
          </div>
          <div className={classes.textBlock}>
            <div className={classes.textTitle}>
              <Skeleton borderRadius='5px' width='100%' height={20} isLight={false} />
            </div>
            {windowWidth > 430 ? (
              <>
                {textDekstop.map((textWidth, index) => (
                  <div className={classes.text} key={index}>
                    <Skeleton borderRadius='5px' width={textWidth} height={15} isLight={false} />
                  </div>
                ))}
                {additionalTextDekstop.map((textWidth, index) => (
                  <div className={classes.text} key={index}>
                    <Skeleton borderRadius='5px' width={textWidth} height={15} isLight={false} />
                  </div>
                ))}
              </>
            ) : (
              <>
                {textMob.map((textWidth, index) => (
                  <div className={classes.text} key={index}>
                    <Skeleton borderRadius='5px' width={textWidth} height={15} isLight={false} />
                  </div>
                ))}
              </>
            )}
          </div>

          <div className={classes.articleInfo}>
            <div className={classes.articleInfoItem}>
              <Skeleton borderRadius='5px' width='66%' height={15} isLight={false} />
            </div>
            <div className={classes.articleInfoItem}>
              <Skeleton borderRadius='5px' width='66%' height={15} isLight={false} />
            </div>
          </div>
        </div>

        <div className={classes.also}>
          <div className={classes.alsotitle}>
            <Skeleton borderRadius='5px' width='76%' height={20} isLight={false} />
          </div>
          <div className={`${classes.articles} skeleton-article-recommended`}>
            {items.map((_, index) => (
              <SkeletonArticlesCard key={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
